<style lang="scss" scoped>
.editor {
    transition: border 0.2s;
    border: 1px solid var(--border-color);
    font-size: 1rem;
    font-weight: 400;
    &:focus {
        border: 1px solid var(--primary);
    }

    label {
        margin-bottom: 0;
        background: #fff;
        left: 11px;
        top: 0px;
        padding: 0;
        color: var(--dark);
        font-weight: 400;
        line-height: 22px;
        display: flex;
    }
}
</style>


<template>
    <div>
        <label class="small">
            <span v-html="label"></span>
        </label>
        <ckeditor v-model="localValue" :editor="editor" @input="handleInput" class="editor" :config="editorConfig"></ckeditor>
    </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';

export default {
    props: {

        /**
         * String, Number defining the value
         * @type {String, Number}
         */
        value: {
            type: [String, Number],
            default: '',
        },

        /**
         * String defining the input label
         * @type {String}
         */
        label: {
            type: String,
            default: '',
        },

        /**
         * String defining the input placeholder
         * @type {String}
         */
        placeholder: {
            type: String,
            default: '',
        },
    },
    components: {
        ckeditor: CKEditor.component,
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                placeholder: this.placeholder,
                plugins: [
                    Essentials,
                    Autoformat,
                    Bold,
                    Italic,
                    BlockQuote,
                    Heading,
                    Alignment,

                    CKFinder,
                    Image,
                    ImageCaption,
                    ImageStyle,
                    ImageToolbar,
                    ImageUpload,

                    Link,
                    MediaEmbed,
                    List,
                    Paragraph,

                ],
                fontFamily: {
                    fontSize: 15,
                    fontFamily: 'Open Sans'
                },

                image: {
                    toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],
                    styles: ['full', 'alignLeft', 'alignRight']
                },

                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'alignment',
                        'bold',
                        'italic',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'mediaEmbed',
                        'imageUpload',
                        '|',
                        'blockQuote',
                        'undo',
                        'redo'
                    ]
                },
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                        { model: 'small', view: 'small', title: 'Small', class: 'ck-heading_headingsmall' },
                    ]
                },
                ckfinder: {
                    uploadUrl: process.env.VUE_APP_API_URL + process.env.VUE_APP_API_VERSION + 'images/upload'
                },
                link: {
                    addTargetToExternalLinks: true,
                    decorators: [
                        {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'download'
                            }
                        }
                    ]
                },
                mediaEmbed: {
                    previewsInData: true
                }
            },
            localValue: this.value
        }
    },
    methods: {
        handleInput() {
            this.$emit('input', this.localValue)
        },
    },
    watch: {
        value() {
            this.localValue = this.value
        }
    }
}
</script>
